import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { CharlieQrCode } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../i18n/i18n';
import { installLinksMap } from '../../components/InstallInstructionsModal';
import appStoreBadge from '../../assets/app-store.svg';
import playStoreBadge from '../../assets/play-store.svg';

type Props = {
  appName: string;
};

/**
 * EmbeddedAppInstallPage — Minimal app install page for iframe context.
 */
export default function EmbeddedAppInstallPage({ appName }: Props) {
  const { t } = useTranslation();
  const links = installLinksMap[appName];
  const displayName = appName || 'your identity app';

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-4 font-inter">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        {links ? (
          <>
            <div className="flex flex-col gap-2 items-center text-center">
              <h2 className="text-xl font-semibold text-foreground">
                {t('installInstructions.title', { appName: displayName })}
              </h2>
              <p className="text-sm text-muted-foreground max-w-xs">
                {t('installInstructions.subtitle', { appName: displayName })}
              </p>
            </div>

            <div className="flex flex-col gap-6 items-center">
              <CharlieQrCode
                data={`${window.location.origin}/?app=${appName}`}
              />
              <div className="flex items-center justify-center gap-3 h-8">
                {links.apple && (
                  <a
                    href={links.apple}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-full"
                  >
                    <img
                      src={appStoreBadge}
                      alt="Download on the App Store"
                      className="h-full w-auto"
                    />
                  </a>
                )}
                {links.android && (
                  <a
                    href={links.android}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-full"
                  >
                    <img
                      src={playStoreBadge}
                      alt="Get it on Google Play"
                      className="h-full w-auto"
                    />
                  </a>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-2 items-center text-center">
            <FontAwesomeIcon
              icon={faCircleInfo}
              className="size-10 text-muted-foreground"
            />
            <h2 className="text-xl font-semibold text-foreground">
              {t('installInstructions.unavailableTitle')}
            </h2>
            <p className="text-sm text-muted-foreground">
              {t('installInstructions.unavailableBody')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
